import axios from 'axios';

let token = localStorage.getItem('accessToken');

const instance = axios.create({
    headers: { Authorization: `Bearer ${token}` }
});

instance.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('adminActivated');
            localStorage.removeItem('rme');
            localStorage.removeItem('rpem');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default instance;
